function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function normalizeLogObject(logObject, level, message) {
  return _objectSpread(_objectSpread({}, logObject), {}, {
    level: level,
    message: message
  });
}

function errorReplacer(_key, value) {
  if (value instanceof Error) {
    var ownProps = Object.getOwnPropertyNames(value);
    var serializedError = {};
    ownProps.forEach(function (prop) {
      serializedError[prop] = value[prop];
    });
    return serializedError;
  }

  return value;
}

var Logger = function () {
  function Logger(options) {
    _classCallCheck(this, Logger);

    this.endpoint = options.endpoint;
    this.onError = options.onError;
  }

  _createClass(Logger, [{
    key: "sendLog",
    value: function sendLog(logObj) {
      var endpoint = this.endpoint,
          onError = this.onError;
      var body = JSON.stringify(logObj, errorReplacer);
      var useSendBeacon = typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';

      if (useSendBeacon) {
        try {
          navigator.sendBeacon(endpoint, new Blob([body], {
            type: 'application/json'
          }));
        } catch (sendBeaconError) {
          useSendBeacon = false;
        }
      }

      if (!useSendBeacon) {
        var fetchOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: body,
          keepalive: true
        };
        fetch(endpoint, fetchOptions)["catch"](function () {
          fetchOptions.keepalive = false;
          fetch(endpoint, fetchOptions)["catch"](function (anotherFetchError) {
            if (onError) {
              onError(anotherFetchError);
            }
          });
        });
      }
    }
  }, {
    key: "log",
    value: function log(logLevel, messageOrLogObj, maybeLogObj, omitStatics) {
      var message;
      var logObj;

      if (typeof messageOrLogObj === 'string') {
        message = messageOrLogObj;
        logObj = maybeLogObj;
      } else {
        logObj = messageOrLogObj;
      }

      var finalLog = omitStatics ? logObj : _objectSpread(_objectSpread({}, logObj), Logger.statics);
      this.sendLog(normalizeLogObject(finalLog !== null && finalLog !== void 0 ? finalLog : {}, logLevel, message));
    }
  }, {
    key: "info",
    value: function info(messageOrLogObj, maybeLogObj, omitStatics) {
      this.log('info', messageOrLogObj, maybeLogObj, omitStatics);
    }
  }, {
    key: "warn",
    value: function warn(messageOrLogObj, maybeLogObj, omitStatics) {
      this.log('warn', messageOrLogObj, maybeLogObj, omitStatics);
    }
  }, {
    key: "error",
    value: function error(messageOrLogObj, maybeLogObj, omitStatics) {
      this.log('error', messageOrLogObj, maybeLogObj, omitStatics);
    }
  }], [{
    key: "setLoggerStatics",
    value: function setLoggerStatics(data) {
      this.statics = data;
    }
  }]);

  return Logger;
}();

export { Logger as default };
//# sourceMappingURL=ClientLogger.js.map